module.exports = __webpack_public_path__ + "static/media/blaine-intro-2.f3660334.wav";